var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5932 7.73442L16.5928 7.73403L11.0485 2.09967C11.0484 2.0996 11.0483 2.09953 11.0482 2.09946C10.6576 1.69811 10.2956 1.4467 9.88006 1.298C9.46678 1.15011 9.01021 1.10742 8.43802 1.10742H3.66673C2.61198 1.10742 1.79606 1.37895 1.24479 1.93817C0.693835 2.49707 0.427734 3.32258 0.427734 4.38671V19.6241C0.427734 20.6928 0.693772 21.5161 1.2451 22.0714C1.79659 22.6269 2.61258 22.8931 3.66673 22.8931H14.3339C15.3933 22.8931 16.2094 22.6243 16.7596 22.0675C17.3095 21.5109 17.5729 20.6877 17.5729 19.6241V10.5037C17.5729 9.85374 17.5381 9.37189 17.3957 8.94596C17.2521 8.51646 17.0028 8.15426 16.5932 7.73442ZM3.74688 21.0261C3.25098 21.0261 2.89292 20.8939 2.65852 20.6606C2.42421 20.4274 2.29473 20.0745 2.29473 19.5941V4.41671C2.29473 3.94156 2.42407 3.58568 2.66023 3.34838C2.89625 3.11122 3.25698 2.97442 3.75716 2.97442H8.09188V8.68571C8.09188 9.33827 8.25776 9.84776 8.60595 10.1932C8.95396 10.5384 9.46318 10.699 10.1052 10.699H15.7059V19.5941C15.7059 20.0751 15.5786 20.4278 15.3456 20.6608C15.1126 20.8938 14.7549 21.0261 14.2537 21.0261H3.74688ZM10.286 8.93185C10.1032 8.93185 10.0061 8.89377 9.95161 8.8386C9.89671 8.78304 9.85816 8.68315 9.85816 8.49456V3.46686L15.2211 8.93225L10.286 8.93185Z",
    fill: "#353535",
    stroke: "#353535",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.ced7b8038c7296ba9dd2153b8d446513.svg";
export { ForwardRef as ReactComponent };